export const rtoStageDropdown = [
  "Hypothecation Termination / By Hand RC Hp Tr/ By Hand Rc",
  "Hypothecation Termination / Hypothecation Endorsement / Transfer Ownership Hp Tr / Hp End / TO",
  "Transfer Ownership TO",
];

export const rtoStatusDropdown1 = [
  "RTO Online Receipt done.",
  "Online Document upload done.(RC, Bank NOC, KYC, Vehicle Photo)",
  "Hard Copy submitted in RTO.",
  "Hypothecation Bank Mail Confirmation pending.",
  "Hypothecation Bank Mail Confirmation done.",
  "Three years old vehicle customer signature pending in RTO.",
  "Three years old vehicle customer signature done in RTO.",
  "Hypothecation Termination document verification pending.",
  "Hypothecation Termination document verification done.",
  "Hypothecation Termination Approval pending.",
  "Hypothecation Termination Approval done.",
  "Hypothecation Termination done.",
  "RC Book Printing Pending.",
  "RC Book printing done and RC Book dispatch pending.",
  "RC Book dispatch customer address.",
];

export const rtoStatusDropdown2 = [
  "RTO Online Receipt done.",
  "Online Document upload done. (RC, Chassis Print, Form 28, 29, 30. Bank NOC Form 35, Form 34 KYC - old Customer, KYC - New Customer , Vehicle Photo)",
  "Hard Copy submitted in RTO. (Online Receipt, RC, Chassis Print, Form 28, 29, 30. Bank NOC Form 35, Form 34 KYC - old Customer, KYC - New Customer , Vehicle Photo)",
  "Hypothecation Bank Mail Confirmation pending.",
  "Hypothecation Bank Mail Confirmation done.",
  "Three years old vehicle customer signature pending in RTO.",
  "Three years old vehicle customer signature done in RTO.",
  "Old Customer Mail confirmation pending.",
  "Old Customer Mail confirmation done.",
  "Hypothecation Termination / Hypothecation Endorsement / Transfer Ownership document verification pending.",
  "Hypothecation Termination / Hypothecation Endorsement / Transfer Ownership document verification done.",
  "Hypothecation Termination / Hypothecation Endorsement / Transfer Ownership Approval pending.",
  "Hypothecation Termination / Hypothecation Endorsement / Transfer Ownership Approval done.",
  "Hypothecation Termination / Hypothecation Endorsement / Transfer Ownership done.",
  "RC Book Printing Pending.",
  "RC Book printing done and RC Book dispatch pending.",
  "RC Book dispatch customer address.",
];

export const rtoStatusDropdown3 = [
    "RTO Online Receipt done.",
    "Online Document upload done. (RC, Chassis Print, Form 28, 29, 30. KYC - old Customer, KYC - New Customer , Vehicle Photo)",
    "Three years old vehicle customer signature pending in RTO.",
    "Three years old vehicle customer signature done in RTO.",
    "Old Customer Mail confirmation pending.",
    "Old Customer Mail confirmation done.",
    "Transfer Ownership document verification pending.",
    "Transfer Ownership document verification done.",
    "Transfer Ownership Approval pending.",
    "Transfer Ownership Approval done.",
    "Transfer Ownership done.",
    "RC Book Printing Pending.",
    "RC Book printing done and RC Book dispatch pending.",
    "RC Book dispatch customer address."
];
